import axios from "axios";

const state = { contentItems: void 0 };

const mutations = {
  SET_CONTENT_ITEMS(state, items) {
    state.contentItems = state.contentItems || [];
    state.contentItems.splice(0, state.contentItems.length);
    state.contentItems.push(...items);
  },
  ADD_CONTENT_ITEMS(state, items) {
    state.contentItems = state.contentItems || [];
    state.contentItems.push(...items);
  },
  ADD_CONTENT_ITEM(state, item) {
    state.contentItems = state.contentItems || [];
    state.contentItems.push(item);
  },
  UPDATE_CONTENT_ITEM(state, item) {
    state.contentItems = state.contentItems || [];

    const foundItem = state.contentItems.find(
      stateItem => stateItem.code === item.code
    );

    if (foundItem) {
      Object.assign(foundItem, item);
    }
  },
  REMOVE_CONTENT_ITEM(state, id) {
    state.contentItems = (state.contentItems || []).filter(
      item => item._id !== id
    );
  }
};

const actions = {
  loadContentItems({ commit, state }) {
    if (state.contentItems) {
      return Promise.resolve();
    }

    return axios
      .get("/api/content-items")
      .then(result => {
        commit("SET_CONTENT_ITEMS", result.data);
      })
      .catch(ignore => commit("ADD_ERROR_MESSAGE", "CONTENT_ITEMS_NOT_LOADED"));
  },
  loadContentItem({ commit, state }, code) {
    if (
      state.contentItems &&
      state.contentItems.find(item => item.code === code)
    ) {
      return Promise.resolve();
    }

    return axios
      .get("/api/content-items", { params: { code } })
      .then(result => {
        commit("ADD_CONTENT_ITEMS", result.data);
      })
      .catch(ignore => commit("ADD_ERROR_MESSAGE", "CONTENT_ITEM_NOT_LOADED"));
  },
  storeContentItem({ commit }, data) {
    if (data.createdAt) {
      return axios
        .put("/api/content-items", { contentItem: data })
        .then(result => {
          commit("UPDATE_CONTENT_ITEM", result.data);
        });
    } else {
      return axios
        .post("/api/content-items", { contentItem: data })
        .then(result => {
          commit("ADD_CONTENT_ITEM", result.data);
        });
    }
  },
  removeContentItem({ commit }, id) {
    return axios.delete("/api/content-items", { params: { id } }).then(() => {
      commit("REMOVE_CONTENT_ITEM", id);
    });
  }
};

export default { state, mutations, actions };
